import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import dayjs from "dayjs";
import { Stack, TextField } from "@mui/material";
import MaterialButton from "../../../../../../components/MaterialButton";


const ClosedTestRun = ({ chartData = [] }) => {
    const [series, setSeries] = useState([]);
    const [categories, setCategories] = useState([]);
    const [view, setView] = useState("overall"); // overall or singleMonth
    const [selectedMonth, setSelectedMonth] = useState(dayjs().format('YYYY-MM'));

    useEffect(() => {
        if (view === "overall") {
            const monthlyData = {};
            chartData.forEach(item => {
                const month = dayjs(item.date).format('MMM YYYY');
                monthlyData[month] = (monthlyData[month] || 0) + item.count;
            });
            setCategories(Object.keys(monthlyData));
            setSeries([{ name: "Closed Test Runs", data: Object.values(monthlyData) }]);
        } else {
            const filtered = chartData.filter(item => dayjs(item.date).format('YYYY-MM') === selectedMonth);
            const dailyData = filtered.map(item => ({ x: dayjs(item.date).format('DD MMM'), y: item.count }));
            setCategories(dailyData.map(d => d.x));
            setSeries([{ name: "Closed Test Runs", data: dailyData.map(d => d.y) }]);
        }
    }, [chartData, view, selectedMonth]);

    const options = {
        chart: {
            id: "closed-test-runs",
            toolbar: {
                show: false
            }
        },
        xaxis: { categories },
        title: { text: `Closed Test Runs - ${view === 'overall' ? 'Overall' : selectedMonth}` },
        dataLabels: { enabled: true },
        stroke: { curve: "smooth" }
    };

    return (
        <div style={{ width: "100%", maxWidth: "650px", margin: "auto", border: '2px solid #e5e7eb', borderRadius: '8px', padding: '9px' }}>
            <Stack direction="row" spacing={2} mb={2} alignItems="center">
                <MaterialButton variant={view === "overall" ? "contained" : "outlined"} color='dark' size="small" onClick={() => setView("overall")}>
                    Overall
                </MaterialButton>
                <MaterialButton variant={view === "singleMonth" ? "contained" : "outlined"} color='dark' size="small" onClick={() => setView("singleMonth")}>
                    Month
                </MaterialButton>
                {view === "singleMonth" && (
                    <TextField
                        type="month"
                        size="small"
                        value={selectedMonth}
                        onChange={e => setSelectedMonth(e.target.value)}
                    />
                )}
            </Stack>
            <Chart options={options} series={series} type="line" height={230} />
        </div>
    )
}

export default ClosedTestRun
